/**
 * MED-TAC International - Consolidated Homepage Scripts
 * Asset: assets/fudge-dKflo-shared.js
 * Deferred execution with data-attribute and element presence guards.
 */

(function() {
  'use strict';

  function init() {
    initHero();
    initMarchDiscovery();
    initBestSellers();
    initDocsChoice();
    initTraumaBrief();
    initSocialHub();
    initFaq();
  }

  /* ----------------------------------------------------
   * 1. Hero v2 Rotator & Slider
   * ---------------------------------------------------- */
  function initHero() {
    var rotator = document.getElementById('fudge-reUnj-rotator');
    if (rotator) {
      var texts = rotator.querySelectorAll('.fudge-reUnj-hero__rotator-text');
      if (texts.length > 1) {
        var current = 0;
        setInterval(function() {
          if (document.hidden) return;
          texts[current].classList.remove('is-active');
          current = (current + 1) % texts.length;
          texts[current].classList.add('is-active');
        }, 4500);
      }
    }

    var bsCard = document.getElementById('fudge-reUnj-hero-bs');
    if (bsCard) {
      var slides = bsCard.querySelectorAll('.fudge-reUnj-hero__product-slide');
      var dots = bsCard.querySelectorAll('.fudge-reUnj-hero__product-card-dot');
      if (slides.length > 1) {
        var bsCurrent = 0;
        setInterval(function() {
          if (document.hidden) return;
          slides[bsCurrent].classList.remove('is-active');
          if (dots[bsCurrent]) dots[bsCurrent].classList.remove('is-active');
          bsCurrent = (bsCurrent + 1) % slides.length;
          slides[bsCurrent].classList.add('is-active');
          if (dots[bsCurrent]) dots[bsCurrent].classList.add('is-active');
        }, 4000);
      }
    }
  }

  /* ----------------------------------------------------
   * 2. MARCH Discovery Tabs & Quick Add
   * ---------------------------------------------------- */
  function initMarchDiscovery() {
    var section = document.querySelector('.fudge-fr-march');
    if (!section) return;

    var tabs = section.querySelectorAll('.fudge-fr-march__tab');
    var panels = section.querySelectorAll('.fudge-fr-march__panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.getAttribute('data-tab');
        tabs.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(p) {
          p.classList.remove('active');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        var panel = section.querySelector('.fudge-fr-march__panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    section.addEventListener('change', function(e) {
      var select = e.target.closest('.fudge-fr-march__card-select');
      if (!select) return;
      var card = select.closest('.fudge-fr-march__card');
      if (!card) return;
      var priceEl = card.querySelector('.fudge-fr-march__card-price');
      var btn = card.querySelector('.fudge-fr-march__card-add');
      var selectedOpt = select.options[select.selectedIndex];
      if (priceEl && selectedOpt) priceEl.textContent = selectedOpt.getAttribute('data-price');
      if (btn) btn.setAttribute('data-variant-id', select.value);
    });

    section.addEventListener('click', function(e) {
      var btn = e.target.closest('.fudge-fr-march__card-add');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('.fudge-fr-march__card');
      var select = card ? card.querySelector('.fudge-fr-march__card-select') : null;
      var variantId = select ? select.value : btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function(r) { return r.json(); })
        .then(function() {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          if (window.SliderCart && typeof window.SliderCart.refresh === 'function') {
            window.SliderCart.refresh();
          }
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
    });
  }

  /* ----------------------------------------------------
   * 3. Best Sellers v2 Show More & Quick Add
   * ---------------------------------------------------- */
  function initBestSellers() {
    var showMoreBtn = document.querySelector('.fudge-reUnj-bestsellers__show-more-btn');
    var grid = document.getElementById('fudge-reUnj-bs-grid');
    if (showMoreBtn && grid) {
      showMoreBtn.addEventListener('click', function() {
        var wrapper = this.closest('.fudge-reUnj-bestsellers__show-more');
        grid.classList.toggle('show-extra');
        if (wrapper) wrapper.classList.toggle('is-expanded');
        this.firstChild.textContent = grid.classList.contains('show-extra') ? 'Show Less' : 'Show More';
      });
    }

    handleQuickAddButtons('.fudge-reUnj-bestsellers__atc.fudge-quick-add-btn');
  }

  /* ----------------------------------------------------
   * 4. Docs Choice v2 Slider & Quick Add
   * ---------------------------------------------------- */
  function initDocsChoice() {
    var slider = document.getElementById('fudge-reUnj-docs-slider');
    if (slider) {
      var navBtns = document.querySelectorAll('.fudge-reUnj-docs__nav-btn');
      navBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var dir = parseInt(this.getAttribute('data-dir'), 10);
          var card = slider.querySelector('.fudge-reUnj-docs__product');
          var scrollAmount = card ? card.offsetWidth + 18 : 278;
          slider.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
        });
      });
    }

    handleQuickAddButtons('.fudge-reUnj-docs__product-atc.fudge-quick-add-btn');
  }

  /* Helper for Best Sellers & Docs Choice Quick Add */
  function handleQuickAddButtons(selector) {
    document.querySelectorAll(selector).forEach(function(btn) {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = this.getAttribute('data-variant-id');
        var textEl = this.querySelector('.text');
        var loadingEl = this.querySelector('.fudge-quick-add-loading');
        if (this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');
        if (textEl) textEl.style.display = 'none';
        if (loadingEl) loadingEl.style.display = 'inline-block';

        try {
          var resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (resp.ok) {
            this.classList.remove('is-loading');
            this.classList.add('add-success');
            if (textEl) { textEl.textContent = 'Added!'; textEl.style.display = 'inline'; }
            if (loadingEl) loadingEl.style.display = 'none';
            document.dispatchEvent(new CustomEvent('cart:add'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (typeof jQuery !== 'undefined') {
              jQuery('body').trigger('ajax:addToCart');
              jQuery('body').trigger('drawer:Minicart');
            }
            if (window.SliderCart && typeof window.SliderCart.refresh === 'function') {
              window.SliderCart.refresh();
            }
            var self = this;
            setTimeout(function() {
              self.classList.remove('add-success');
              if (textEl) textEl.textContent = 'Add to Cart';
            }, 1500);
          } else {
            this.classList.remove('is-loading');
            if (textEl) { textEl.textContent = 'Error'; textEl.style.display = 'inline'; }
            if (loadingEl) loadingEl.style.display = 'none';
            var self = this;
            setTimeout(function() { if (textEl) textEl.textContent = 'Add to Cart'; }, 2000);
          }
        } catch(err) {
          this.classList.remove('is-loading');
          if (textEl) { textEl.textContent = 'Error'; textEl.style.display = 'inline'; }
          if (loadingEl) loadingEl.style.display = 'none';
          var self = this;
          setTimeout(function() { if (textEl) textEl.textContent = 'Add to Cart'; }, 2000);
        }
      });
    });
  }

  /* ----------------------------------------------------
   * 5. Homepage Trauma Brief Form
   * ---------------------------------------------------- */
  function initTraumaBrief() {
    var form = document.getElementById('fudgeHomeBriefForm');
    var emailInput = document.getElementById('fudgeHomeBriefEmail');
    var btn = document.getElementById('fudgeHomeBriefBtn');
    var successEl = document.getElementById('fudgeHomeBriefSuccess');
    var privacyEl = document.getElementById('fudgeHomeBriefPrivacy');
    var PDF_BRIEF_URL = 'https://cdn.shopify.com/s/files/1/0085/6909/4262/files/the-trauma-brief-v2.pdf?v=1791473899';
    var PDF_FIELD_GUIDE_URL = 'https://cdn.shopify.com/s/files/1/0085/6909/4262/files/the-trauma-brief-field-guide.pdf?v=1791473899';

    if (!form || !emailInput || !btn || !successEl) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = (emailInput.value || '').trim();
      if (!email) return;

      btn.textContent = 'Opening Guides...';
      btn.disabled = true;

      try {
        window.open(PDF_BRIEF_URL, '_blank');
      } catch(err) {}
      try {
        window.open(PDF_FIELD_GUIDE_URL, '_blank');
      } catch(err) {}

      var completeSubmission = function() {
        form.style.display = 'none';
        if (privacyEl) privacyEl.style.display = 'none';
        successEl.style.display = 'block';
      };

      var contactParams = new FormData();
      contactParams.append('form_type', 'contact');
      contactParams.append('utf8', '✓');
      contactParams.append('contact[email]', email);
      contactParams.append('contact[body]', 'Trauma Brief & Field Guide Download Request from Homepage');
      fetch('/contact', {
        method: 'POST',
        body: contactParams,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).catch(function() {});

      if (typeof window.medtacKlaviyoFullCapture === 'function') {
        window.medtacKlaviyoFullCapture({
          email: email,
          listId: 'WhiVZE',
          leadSource: 'Homepage Trauma Brief',
          guide: 'The Trauma Brief + Field Guide',
          eventName: 'Trauma Brief Downloaded',
          eventProperties: {
            page: window.location.pathname,
            pdf_brief_url: PDF_BRIEF_URL,
            pdf_field_guide_url: PDF_FIELD_GUIDE_URL
          }
        }).then(completeSubmission).catch(completeSubmission);
      } else {
        completeSubmission();
      }
    });
  }

  /* ----------------------------------------------------
   * 6. Social Feed Tabs & Lazy YouTube Embed
   * ---------------------------------------------------- */
  function initSocialHub() {
    var hub = document.querySelector('.fudge-social-hub');
    if (!hub) return;

    var tabs = hub.querySelectorAll('.fudge-social-hub__tab');
    var panels = hub.querySelectorAll('.fudge-social-hub__panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.getAttribute('data-tab');

        tabs.forEach(function(t) { t.classList.remove('fudge-social-hub__tab--active'); });
        panels.forEach(function(p) { p.classList.remove('fudge-social-hub__panel--active'); });

        this.classList.add('fudge-social-hub__tab--active');
        var matchingPanel = hub.querySelector('[data-panel="' + target + '"]');
        if (matchingPanel) matchingPanel.classList.add('fudge-social-hub__panel--active');

        if (target === 'youtube' && !window._fudgeYtLoaded) {
          loadYouTube();
        }
      });
    });

    // Lazy load YouTube RSS only when section is within 250px of viewport
    if ('IntersectionObserver' in window) {
      var hubObserver = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          if (!window._fudgeYtLoaded) {
            loadYouTube();
          }
          hubObserver.disconnect();
        }
      }, { rootMargin: '250px 0px' });
      hubObserver.observe(hub);
    } else {
      loadYouTube();
    }

    function loadYouTube() {
      window._fudgeYtLoaded = true;
      var container = document.getElementById('fudge-hub-yt-grid');
      if (!container) return;

      var playlistId = 'PL1pDR8ZFGUG6mFD_4b0LAAkQpGytJe4zn';
      var rssUrl = 'https://www.youtube.com/feeds/videos.xml?playlist_id=' + playlistId;

      function renderVideos(items) {
        var html = '';
        items.forEach(function(item) {
          var videoId = item.link.split('v=')[1] || '';
          if (videoId.indexOf('&') > -1) videoId = videoId.split('&')[0];
          var thumb = 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';
          var title = item.title || 'Untitled';
          var pubDate = new Date(item.pubDate);
          var dateStr = pubDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

          html += '<a href="' + item.link + '" target="_blank" rel="noopener" class="fudge-social-hub__yt-card">' +
            '<div class="fudge-social-hub__yt-thumb">' +
              '<img src="' + thumb + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async" width="480" height="270">' +
              '<div class="fudge-social-hub__yt-play"><svg width="20" height="20" viewBox="0 0 24 24"><polygon points="9,6 19,12 9,18"/></svg></div>' +
            '</div>' +
            '<div class="fudge-social-hub__yt-body">' +
              '<h3 class="fudge-social-hub__yt-title">' + title + '</h3>' +
              '<span class="fudge-social-hub__yt-date">' + dateStr + '</span>' +
            '</div>' +
          '</a>';
        });
        container.innerHTML = html;
      }

      function showError() {
        if (container.querySelectorAll('.fudge-social-hub__yt-card').length > 0) return;
        container.innerHTML = '<p class="fudge-social-hub__yt-error">Unable to load videos. <a href="https://www.youtube.com/@talkingtacmed" target="_blank" rel="noopener" style="color:#9c8f61;">Visit our channel</a></p>';
      }

      function parseAtomXml(xmlText) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(xmlText, 'text/xml');
        var entries = doc.querySelectorAll('entry');
        if (entries.length === 0) throw new Error('No entries in XML');

        var items = [];
        entries.forEach(function(entry) {
          var linkEl = entry.querySelector('link');
          var titleEl = entry.querySelector('title');
          var pubDateEl = entry.querySelector('published');
          items.push({
            link: linkEl ? linkEl.getAttribute('href') : '',
            title: titleEl ? titleEl.textContent : 'Untitled',
            pubDate: pubDateEl ? pubDateEl.textContent : ''
          });
        });
        return items.slice(0, 6);
      }

      var proxies = [
        'https://api.codetabs.com/v1/proxy/?quest=' + encodeURIComponent(rssUrl),
        'https://corsproxy.io/?url=' + encodeURIComponent(rssUrl),
        'https://api.allorigins.win/raw?url=' + encodeURIComponent(rssUrl)
      ];

      function tryProxy(index) {
        if (index >= proxies.length) {
          showError();
          return;
        }
        fetch(proxies[index])
          .then(function(res) { return res.text(); })
          .then(function(xmlText) {
            try {
              renderVideos(parseAtomXml(xmlText));
            } catch(e) {
              tryProxy(index + 1);
            }
          })
          .catch(function() {
            tryProxy(index + 1);
          });
      }

      tryProxy(0);
    }
  }

  /* ----------------------------------------------------
   * 7. Homepage FAQ Accordions
   * ---------------------------------------------------- */
  function initFaq() {
    var faqContainer = document.getElementById('fudge-hp-faq-list');
    if (!faqContainer) return;

    var items = faqContainer.querySelectorAll('.fudge-hp-faq__item');
    items.forEach(function(item) {
      var btn = item.querySelector('.fudge-hp-faq__question');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var isOpen = item.classList.contains('fudge-hp-faq__item--open');
        items.forEach(function(other) {
          other.classList.remove('fudge-hp-faq__item--open');
          var otherBtn = other.querySelector('.fudge-hp-faq__question');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('fudge-hp-faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
